<template>
  <div class="pc-search">
    <el-form :model="keywordData" :inline="true">
      <el-form-item label="作品名称" class="competition">
        <el-input v-model="keywordData.name_keywords[0]"></el-input>
      </el-form-item>
            <el-form-item label="作品号码" class="competition">
        <el-input v-model="keywordData.works_code"></el-input>
      </el-form-item>
      <br />
          <el-form-item label="预审核" placeholder="预审核" clearable class="status">
        <el-select v-model="keywordData.pre_audit" clearable placeholder="预审核">
          <el-option label="未通过" value="0"></el-option>
          <el-option label="已通过" value="1"></el-option>
        </el-select>
      </el-form-item>
                <el-form-item label="提交状态" placeholder="提交状态" clearable class="submit">
        <el-select v-model="keywordData.submit" clearable placeholder="提交状态">
          <el-option label="提交" value="1"></el-option>
          <el-option label="未提交" value="0"></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <button class="pc-search-btn" @click="search">筛选</button>
  </div>
</template>

<script>

export default {
  data() {
    return {
      keywordData: {
        competition_id: null,
        name_keywords: [],
        works_code: "",
        pre_audit: "",
        submit:null
      },

    };
  },
  mounted() {

  },
  methods: {
    search() {
      console.log(this.keywordData);
      this.$emit("search", this.keywordData);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-range-editor.el-input__inner {
  width: 490px;
}
.pc-search {
  @include table-search;
  .competition {
    width: 400px;
  }
  .title {
    width: 600px;
  }
  .updateTime {
    width: 600px;
  }
  .is-wupen {
    width: 200px;
    margin-right: 110px;
  }
  .tag {
    width: 300px;
    /deep/ .qh-tag {
      line-height: 24px;
    }
  }
  .status {
    width: 250px;
  }
  .keyword {
    width: 400px;
    height: 40px;
    /deep/ .qh-tag {
      line-height: 24px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/competition/components/NewCompetitionWorkSearch.vue